<template lang="pug">
  .footer
    .pull-right
      p {{ copyright }}
    .clearfix
</template>

<style lang="stylus">
.footer
  background: #2a3f54
  padding: 17px
  p
    margin: 0
    font-size: 13px
</style>

<script>
export default {
  data () {
    return {
      copyright: `Copyright (C) ${new Date().getFullYear()} Media-Tech co.,ltd. All Rights Reserved.`
    }
  }
}
</script>



// WEBPACK FOOTER //
// Footer.vue?53a1d7a7